export interface StatementsTableColumn {
  label: string;
  colSpan?: number;
  align?: "left" | "center" | "right";
}

export const STATEMENTS_TABLE_COLUMNS: StatementsTableColumn[] = [
  { label: "#", align: "left" },
  { label: "Name" },
  { label: "Date" },
  { label: "Charges" },
  { label: "Due from" },
  { label: "Status", colSpan: 2, align: "left" },
  { label: "Closed" },
  { label: "Balance" },
  { label: "Actions" },
];

export const STATEMENTS_TABLE_COLUMN_SPAN = STATEMENTS_TABLE_COLUMNS.reduce(
  (total, column) => total + (column.colSpan ?? 1),
  0,
);

export const STATEMENT_STATUS = {
  Unsent: "Unsent",
  Sent: "Sent",
  Accepted: "Accepted",
  Processing: "In Processing",
  Paid: "Paid",
  Denied: "Denied",
  Rejected: "Rejected",
  Cancelled: "Deleted",
} as const;

export type StatementStatus = (typeof STATEMENT_STATUS)[keyof typeof STATEMENT_STATUS];

export const STATEMENT_STATUS_COLOR: Record<StatementStatus, string> = {
  [STATEMENT_STATUS.Unsent]: "gray.5",
  [STATEMENT_STATUS.Sent]: "blue.5",
  [STATEMENT_STATUS.Accepted]: "green.7",
  [STATEMENT_STATUS.Processing]: "orange.5",
  [STATEMENT_STATUS.Paid]: "green.7",
  [STATEMENT_STATUS.Denied]: "red.5",
  [STATEMENT_STATUS.Rejected]: "red.7",
  [STATEMENT_STATUS.Cancelled]: "red.7",
};

export const STATEMENT_STATUS_BACKGROUND_COLOR: Record<StatementStatus, string> = {
  [STATEMENT_STATUS.Unsent]: "gray.2",
  [STATEMENT_STATUS.Sent]: "blue.1",
  [STATEMENT_STATUS.Accepted]: "green.1",
  [STATEMENT_STATUS.Processing]: "orange.1",
  [STATEMENT_STATUS.Paid]: "green.1",
  [STATEMENT_STATUS.Denied]: "red.1",
  [STATEMENT_STATUS.Rejected]: "red.1",
  [STATEMENT_STATUS.Cancelled]: "red.1",
};

export const INSURANCE_STATEMENT_STATUS_OPTIONS: StatementStatus[] = [
  STATEMENT_STATUS.Unsent,
  STATEMENT_STATUS.Sent,
  STATEMENT_STATUS.Accepted,
  STATEMENT_STATUS.Rejected,
];

export const STATEMENT_ACCEPTED_SUB_STATUS_OPTIONS: StatementStatus[] = [
  STATEMENT_STATUS.Processing,
  STATEMENT_STATUS.Paid,
  STATEMENT_STATUS.Denied,
];

export const SELF_PAY_STATEMENT_STATUS_OPTIONS: StatementStatus[] = [
  STATEMENT_STATUS.Unsent,
  STATEMENT_STATUS.Sent,
  STATEMENT_STATUS.Paid,
  STATEMENT_STATUS.Denied,
];

export const STATEMENTS_PAGE_SIZE = 20;
